import { Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "./components/AppLayout";
import { AssetDetailsPage } from "./pages/AssetDetailsPage";
import { AssetsPage } from "./pages/AssetsPage";
import { FactDetailsPage } from "./pages/FactDetailsPage";
import { FactsPage } from "./pages/FactsPage";
import { HomePage } from "./pages/HomePage";
import { PassportPage } from "./pages/PassportPage";
import { SearchPage } from "./pages/SearchPage";
import { WordingDetailsPage } from "./pages/WordingDetailsPage";
import { WordingPage } from "./pages/WordingPage";

export default function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/passport" element={<PassportPage />} />
        <Route path="/facts" element={<FactsPage />} />
        <Route path="/facts/:factId" element={<FactDetailsPage />} />
        <Route path="/wording" element={<WordingPage />} />
        <Route path="/wording/:wordingId" element={<WordingDetailsPage />} />
        <Route path="/assets" element={<AssetsPage />} />
        <Route path="/assets/:assetId" element={<AssetDetailsPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
